<template>
    <div class="program-info-content">
        <div class="program-info-content__wrap-img" :class="{'program-info-content__wrap-img_blur': isParentallyRestricted}">
            <img 
                v-if="props.srcImg"
                class="program-info-content__img" 
                :alt="props.programName || ''" 
                :src="props.srcImg"
            >
            <common-icon v-else :icon-name="'IconNoPicture'" />
        </div>
        <div class="program-info-content__info">
            <h1 class="program-info-content__title">{{ props.programName }}</h1>
            <div class="program-info-content__short-info">
                <div v-if="props.channelNumber && props.channelCallSign" class="program-info-content-short-info__text">{{ props.channelNumber }} {{ props.channelCallSign }}</div>
                <div v-if="props.time" class="program-info-content-short-info__text">{{ props.time }}</div>
                <program-labels
                    :advisory-text="props.advisoryText"
                    :high-definition="props.highDefinition"
                    :closed-captions="props.closedCaptions"
                    :descriptive-audio="props.descriptiveAudio"
                    :is-restart-available="props.isRestartAvailable"
                />
            </div>
            <div class="program-info-content__description">{{ props.description }}</div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { IProgramInfo } from "@/composables/useProgramInfo/types";
    import { useParentControl } from "@/composables/parentControl/useParentControl";
    
    const props = defineProps<{
        programName: IProgramInfo['programName'];
        channelCallSign: IProgramInfo['channelCallSign'];
        channelNumber: IProgramInfo['channelNumber'];
        time: IProgramInfo['time'];
        description: IProgramInfo['description'];
        srcImg: IProgramInfo['srcImg'];
        advisoryText: IProgramInfo['advisoryText'];
        advisory: IProgramInfo['advisory'];
        highDefinition: IProgramInfo['highDefinition'];
        closedCaptions: IProgramInfo['closedCaptions'];
        descriptiveAudio: IProgramInfo['descriptiveAudio'];
        isRestartAvailable: IProgramInfo['isRestartAvailable'];
    }>();
    const { needsUnlockPin } = useParentControl()
    const isParentallyRestricted = computed((): boolean => needsUnlockPin(props.advisory));
</script>